<nb-card class="dialog-card">
  <nb-card-header>Neues Protokoll</nb-card-header>
  <nb-card-body>

    <!-- Mode selector -->
    <div class="mode-selector">
      <div
        class="mode-card"
        [class.active]="mode() === 'building'"
        (click)="setMode('building')"
        role="button"
        tabindex="0"
        (keydown.enter)="setMode('building')"
        (keydown.space)="setMode('building'); $event.preventDefault()">
        <nb-icon pack="eva" icon="home-outline"></nb-icon>
        <span>Gebäude</span>
      </div>
      <div
        class="mode-card"
        [class.active]="mode() === 'tga'"
        (click)="setMode('tga')"
        role="button"
        tabindex="0"
        (keydown.enter)="setMode('tga')"
        (keydown.space)="setMode('tga'); $event.preventDefault()">
        <nb-icon pack="eva" icon="cube-outline"></nb-icon>
        <span>TGA</span>
      </div>
    </div>

    <!-- Building mode -->
    <ng-container *ngIf="mode() === 'building'">
      <div class="field">
        <label class="label">Gebäude</label>
        <wr-building-select [(ngModel)]="selectedBuilding"></wr-building-select>
      </div>
    </ng-container>

    <!-- TGA mode -->
    <ng-container *ngIf="mode() === 'tga'">
      <div class="field">
        <label class="label">Gebäude <span class="required">*</span></label>
        <wr-building-select
          [ngModel]="selectedBuildingForTga"
          (ngModelChange)="onBuildingForTgaChange($event)">
        </wr-building-select>
      </div>
      <div class="field">
        <label class="label">TGA Bauteil <span class="required">*</span></label>
        <wr-building-equipment-select
          [buildingEquipments]="(buildingEquipments$ | async) ?? undefined"
          [ngModel]="selectedBuildingEquipmentId"
          (ngModelChange)="onBuildingEquipmentChange($event)"
          [disabled]="!selectedBuildingForTga">
        </wr-building-equipment-select>
      </div>
    </ng-container>

    <!-- Protocol type (always visible) -->
    <div class="field">
      <label class="label">Protokolltyp <span class="required">*</span></label>
      <nb-select fullWidth placeholder="Protokolltyp wählen..." [(ngModel)]="selectedProtocolTypeId">
        <nb-option *ngFor="let pt of protocolTypes$ | async" [value]="pt.id">
          <span class="type-badge" [style.background]="pt.color">{{ pt.shortcut }}</span>
          {{ pt.name }}
        </nb-option>
      </nb-select>
    </div>

  </nb-card-body>
  <nb-card-footer class="dialog-footer">
    <button nbButton status="basic" (click)="cancel()">Abbrechen</button>
    <button nbButton status="primary" [disabled]="!canConfirm" (click)="confirm()">
      Weiter
      <nb-icon icon="arrow-forward-outline" pack="eva"></nb-icon>
    </button>
  </nb-card-footer>
</nb-card>
